// MOMERY CUSTOM — Printess save/share product-page restoration.
(function () {
  const url = new URL(window.location.href);
  const saveToken = url.searchParams.get('savetoken');
  if (!saveToken) return;

  const TRACKING_KEYS = ['_pos', '_psq', '_ss', '_v'];

  const cleanUrl = () => {
    const u = new URL(window.location.href);

    TRACKING_KEYS.forEach((k) => u.searchParams.delete(k));

    // Für Debug erstmal drin lassen:
    // u.searchParams.delete('savetoken');

    window.history.replaceState({}, '', u.toString());
  };

  // Wir cleanen nur EINMAL
  let cleaned = false;
  const runOnce = () => {
    if (cleaned) return;
    cleaned = true;
    cleanUrl();
    document.removeEventListener('printess:saved', onSaved);
    clearTimeout(fallbackTimer);
  };

  const onSaved = () => runOnce();

  // 1) Best case: nach erstem Save (deine bestehende Logik)
  document.addEventListener('printess:saved', onSaved);

  // 2) Fallback: falls nie gespeichert wird (z.B. User schließt)
  // -> etwas kürzer und "once" sauber
  const fallbackTimer = setTimeout(runOnce, 8000);
})();
